import React, { useEffect, useState } from 'react';
import proptypes from 'prop-types';
import config from '@/config';
import { Link, withRouter } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import IconPlus from '@/assets/images/icons/icons-plus.svg';
import IconMinus from '@/assets/images/icons/icons-minus.svg';
import IconTicket from '@/assets/images/icons/icons-ticket.svg';
import SignOut from '../sign-out';
import './site-menu.scss';

const { SubMenu } = Menu;
const menu = [
  {
    title: 'Ticket',
    key: 'ticket',
    icon: IconTicket,
    children: [{ label: 'Ticket List', url: `${config.contextPath}/ticket` }],
  },
];

const getExpandIcon = ({ isOpen }) => (
  <img src={isOpen ? IconMinus : IconPlus} alt="expand icon" className="expand-icon icon" />
);

const SiteMenu = ({ location }) => {
  const [openKeysValue, setOpenKeys] = useState(['sub1']);
  const [selectedKeys, setSelectedKeys] = useState(['sub1']);

  /**
   * Get menus active
   * @param {*} path
   * @returns
   */
  const getActiveKeys = () => {
    let path = location.pathname;
    const activeKeys = [];
    const openKeys = [];
    const defaultActiveMenu = '/product';
    if (path === '/') {
      path = defaultActiveMenu;
    }
    menu.forEach(({ key, children }) => {
      children.forEach(({ url }) => {
        if (path.indexOf(url) !== -1) {
          activeKeys.push(url);
          openKeys.push(key);
        }
      });
    });
    setSelectedKeys(activeKeys);
    return setOpenKeys(openKeys);
  };

  useEffect(() => {
    getActiveKeys();
  }, [location]);

  const onOpenChange = (openKeys) => {
    const nOpenKeys = openKeys.pop();
    setOpenKeys([nOpenKeys]);
  };

  const renderSubMenu = () =>
    menu.map(({ key, title, icon, children }) => (
      <SubMenu
        key={key}
        title={title}
        icon={<img src={icon} alt="more menu icon" className="more-icon icon" />}
      >
        {children.map(({ label, url }) => (
          <Menu.Item key={url}>
            <Link to={url}>{label}</Link>
          </Menu.Item>
        ))}
      </SubMenu>
    ));

  return (
    <Layout.Sider className="site-menu" width="240">
      <Menu
        selectedKeys={selectedKeys}
        defaultOpenKeys={['inventory']}
        openKeys={openKeysValue}
        mode="inline"
        className="side-menu"
        expandIcon={(props) => getExpandIcon(props)}
        onOpenChange={onOpenChange}
      >
        {renderSubMenu()}
      </Menu>
      <SignOut location={location} />
    </Layout.Sider>
  );
};

SiteMenu.propTypes = {
  location: proptypes.any,
};
export default withRouter(SiteMenu);
